/**
 * Cart drawer scroll fix.
 *
 * <coretex-cart> is the element that actually clips overflow (overflow: hidden
 * is forced on it in dani.css) so it is the real visible boundary for the drawer
 * body. Earlier versions of this fix derived cart-body's available height from
 * dialog/header/footer measurements, which assumes the flex chain above
 * <coretex-cart> resolves to exactly 100% — if it's off by even a little,
 * cart-body ends up taller than what <coretex-cart> actually shows, silently
 * cropping the bottom off without cart-body itself ever needing to scroll.
 *
 * This measures <coretex-cart>'s own rendered box directly and subtracts its
 * visible siblings (item count, free shipping / announcement bar, footer) from
 * that, so cart-body's max-height can never exceed what's actually visible.
 */
(() => {
    let cartBodyEl, coretexCartEl, footerEl, itemCountEl, gridEl;
    let resizeObserver;

    function computeAndApply() {
        if (!cartBodyEl || !coretexCartEl) return;

        const containerHeight = coretexCartEl.getBoundingClientRect().height;
        const footerHeight = footerEl ? footerEl.getBoundingClientRect().height : 0;
        const itemCountHeight = itemCountEl ? itemCountEl.getBoundingClientRect().height : 0;

        // Sum anything that sits before cart-body inside the grid (free shipping
        // bar / announcement bar), whatever it happens to be, rather than
        // guessing tag names.
        let topSiblingsHeight = 0;
        if (gridEl) {
            let node = gridEl.firstElementChild;
            while (node && node !== cartBodyEl) {
                topSiblingsHeight += node.getBoundingClientRect().height;
                node = node.nextElementSibling;
            }
        }

        const available = containerHeight - footerHeight - itemCountHeight - topSiblingsHeight;

        if (available > 40) {
            cartBodyEl.style.maxHeight = available + 'px';
            cartBodyEl.style.overflowY = 'auto';
        }
    }

    function setupObservers() {
        const cartBox = document.getElementById('cartBox');
        if (!cartBox) return;

        const dialogEl = cartBox.querySelector('dialog');
        if (!dialogEl) return;

        coretexCartEl = dialogEl.querySelector('coretex-cart');
        if (!coretexCartEl) return;

        gridEl = coretexCartEl.querySelector('x-grid.coretex-cart');
        cartBodyEl = coretexCartEl.querySelector('cart-body');
        footerEl = coretexCartEl.querySelector('cart-footer');
        itemCountEl = coretexCartEl.querySelector('.cart-item-count');

        if (resizeObserver) resizeObserver.disconnect();

        if (!cartBodyEl) return; // empty cart, nothing to scroll

        resizeObserver = new ResizeObserver(computeAndApply);
        resizeObserver.observe(coretexCartEl);
        if (footerEl) resizeObserver.observe(footerEl);
        if (itemCountEl) resizeObserver.observe(itemCountEl);
        if (gridEl) resizeObserver.observe(gridEl);

        computeAndApply();
    }

    document.addEventListener('DOMContentLoaded', setupObservers);

    // Re-run whenever the cart drawer content is re-rendered via AJAX.
    document.addEventListener('liquid-ajax-cart:request-end', setupObservers);

    // Re-run when the dialog opens (covers first-open timing edge cases in
    // browsers that fire a "toggle" event on <dialog>).
    document.addEventListener('toggle', (event) => {
        if (event.target?.tagName === 'DIALOG' && event.target.closest('#cartBox')) {
            setupObservers();
        }
    }, true);

    // Re-run on viewport changes (orientation change, mobile browser chrome
    // showing/hiding, which changes the real available height).
    window.addEventListener('resize', () => computeAndApply());
})();
